import { gql } from "@apollo/client";

export const CREATE_VIDEO = gql`
  mutation CreateVideo($input: CreateVideoInput!) {
    createVideo(input: $input) {
      data {
        clientPayload {
          key
          policy
          uploadLink
          video_id
          x_amz_algorithm
          x_amz_credential
          x_amz_date
          x_amz_signature
        }
        video {
          created_at
          featured
          id
          identifier
          otp
          playback_info
          season_folder_id
          title
          updated_at
          upload_status
          video
          visibility
          thumbnail
          packages {
            updated_at
            id
            package_id
            content_type
            ref_id
            created_at
            package {
              id
              name
              description
              package_type
              created_at
              updated_at
            }
          }
          category {
            created_at
            description
            folder_id
            group_id
            id
            name
            updated_at
          }
          episode {
            created_at
            episode_number
            id
            label
            season_id
            series_id
            updated_at
          }
        }
      }
      error {
        code
        field
        message
      }
    }
  }
`;

export const UPDATE_VIDEO = gql`
  mutation EditVideo($input: CreateVideoInput!, $video_id: UUID) {
    editVideo(input: $input, video_id: $video_id) {
      data {
        video {
          created_at
          featured
          id
          identifier
          otp
          playback_info
          season_folder_id
          title
          updated_at
          upload_status
          video
          visibility
          thumbnail
          packages {
            updated_at
            id
            package_id
            content_type
            ref_id
            created_at
            package {
              id
              name
              description
              package_type
              created_at
              updated_at
            }
          }
          category {
            created_at
            description
            folder_id
            id
            name
            group_id
          }
          episode {
            episode_number
            id
            label
            season_id
            series_id
          }
        }
        clientPayload {
          key
          policy
          uploadLink
          video_id
          x_amz_algorithm
          x_amz_credential
          x_amz_date
          x_amz_signature
        }
      }
      error {
        code
        field
        message
      }
    }
  }
`;

export const DELETE_VIDEO = gql`
  mutation DeleteVideo($video_id: UUID) {
    deleteVideo(video_id: $video_id) {
      error {
        message
      }
      data {
        message
      }
    }
  }
`;
export const UPLOAD_VIDEO = gql`
  mutation UploadVideo(
    $title: String
    $folder_id: String
    $create_video_id: UUID
  ) {
    uploadVideo(
      title: $title
      folder_id: $folder_id
      create_video_id: $create_video_id
    ) {
      data {
        client_playload {
          key
          policy
          uploadLink
          video_id
          x_amz_algorithm
          x_amz_credential
          x_amz_date
          x_amz_signature
        }
      }
      error {
        code
        field
        message
      }
    }
  }
`;
export const UPDATE_SINGLE_DATA_BY_VIDEO_ID = gql`
  mutation UpdateSingleDataByVideoId($input: UpdateSingleDataByVideoIdInput!) {
    updateSingleDataByVideoId(input: $input) {
      data {
        video {
          created_at
          featured
          id
          identifier
          otp
          playback_info
          season_folder_id
          title
          updated_at
          upload_status
          video
          visibility
          thumbnail
          packages {
            updated_at
            id
            package_id
            content_type
            ref_id
            created_at
            package {
              id
              name
              description
              package_type
              created_at
              updated_at
            }
          }
          category {
            created_at
            description
            folder_id
            id
            name
            group_id
          }
          episode {
            episode_number
            id
            label
            season_id
            series_id
          }
        }
        clientPayload {
          key
          policy
          uploadLink
          video_id
          x_amz_algorithm
          x_amz_credential
          x_amz_date
          x_amz_signature
        }
      }
      error {
        code
        field
        message
      }
    }
  }
`;
export const CHECK_VIDEO_STATUS = gql`
  mutation CheckVideoStatus($video_id: UUID) {
    checkVideoStatus(video_id: $video_id) {
      data {
        video_status {
          description
          id
          ip_geo_rules
          length
          poster
          posters
          public
          status
          stream_type
          tags
          title
          total_size_bytes
          upload_status
          upload_time
          white_lis_thref
        }
      }
      error {
        code
        field
        message
      }
    }
  }
`;

export const UPSERT_PACKAGE_CONTENTS = gql`
 mutation UpsertPackageContents($package_ids: [UUID!]!, $content_type: String!, $ref_id: UUID!) {
      UpsertPackageContents(package_ids: $package_ids, content_type: $content_type, ref_id: $ref_id) {
        data {
            package_content {
                ref_id
                created_at
                updated_at
                id
                package_id
                content_type
                package {
                    updated_at
                    id
                    name
                    description
                    package_type
                    created_at
                }
            }
        }
        error {
            code
            field
            message
        }
    }
}
`;
